import { once } from 'underscore';
export function conditionallyRunDiffsBasedOnPercentage(percentage) {
  return once(() => {
    return Math.random() <= percentage;
  });
}
export const runDiffsOnTwentyFivePercentOfAppLoads = conditionallyRunDiffsBasedOnPercentage(0.25);
export const runDiffsOnFiftyPercentOfAppLoads = conditionallyRunDiffsBasedOnPercentage(0.5);